const getModuleContents = (module, contents, transform) =>
  contents
    .filter(
      field => module.split('|').indexOf(Object.keys(field)[0].trim()) > -1
    )
    .map(
      item =>
        transform
          ? setFieldKeys(getModuleDetails(item[module], !transform).fields)
          : getModuleDetails(item[module], !transform).fields
    )

const getModuleDetails = (fields, isNav) => {
  let itemIndex = 0

  fields.some((field, index) => {
    itemIndex = index
    return (
      field.title ===
      (field.type === 'Matrix' && isNav ? 'NAVIGATION' : 'MODULE DETAILS')
    )
  })

  return fields[itemIndex]
};

const setFieldKeys = fields =>
  fields.reduce((total, current) => {
    if (!current.title) {
      return total
    }

    total[current.title] = current
    return total
  }, {})

const sortBeerFields = (contents, pageName, startIndex) => {
  let sortedContent = []

  contents.slice(startIndex, contents.length).every(contentItem => {
    let moduleName = '';
    const samePage = contentItem.fields.some(
      field => field.title === 'PAGE NAME' && field.value === pageName
    )

    contentItem.fields.some(field => {
      if (field.title === 'MODULE') {
        moduleName = field.value
      }

      return field.title === 'MODULE';
    })

    if (samePage) {
      sortedContent.push({ [moduleName]: contentItem.fields })
    }

    return samePage
  })

  return sortedContent
};

const sortBeers = contents => {
  const final = {}

  contents.forEach((content, index) =>
    content.fields.forEach(
      field =>
        field.title === 'PAGE NAME' && !final[field.value]
          ? (final[field.value] = sortBeerFields(contents, field.value, index))
          : null
    )
  )
  return final
};

const getBeerMeta = contents => {
  const metaData = {}

  const meta = contents[0]['Back button'] && contents[0]['Back button'].find(field => field.title === 'MetaData' || field.id === 'metadata')
  const detailsmodule = contents[0]['Back button'] && contents[0]['Back button'].find(field => field.title === 'DETAILS MODULE' || field.id === 'detailsmodule')
  if (!meta) {
    return {}
  }

  metaData.title = meta.fields[0].value
  metaData.description = meta.fields[1].value
  metaData.sortIndex = detailsmodule.fields[0].value

  return metaData
};

export default (modules, contents, transform = true) => {
  const beerContents = sortBeers(contents)
  const finalContents = {}

  modules.forEach(module => {
    Object.keys(beerContents).forEach(beer => {
      if (!finalContents[beer]) {
        finalContents[beer] = {}
      }

      finalContents[beer][module.title] = getModuleContents(
        module.name,
        beerContents[beer],
        transform
      )

      finalContents[beer].meta = getBeerMeta(beerContents[beer])
    })
  })

  return finalContents
};



// WEBPACK FOOTER //
// ./src/pages/beers/build-beer-json.js